/* ============================================================
   Fit Creamery — Shopify Forms star rating
   File:    assets/fc-form-stars.js
   Loaded:  by sections/fc-form-stars.liquid

   Shopify Forms renders inside an open shadow root, so theme CSS can't
   style it. This script:
   1. fetches assets/fc-form-stars.css and adds it to each form's shadow
      root as an adopted stylesheet;
   2. marks every radio fieldset whose options are exactly 1–5 with
      [data-fc-stars], which that CSS turns into stars. (The same CSS
      also styles the submit button green.)

   The form app attaches its shadow root and renders its fields after
   page load, so we poll for the root, then watch it for re-renders
   (e.g. after a failed submit) to re-mark fieldsets and re-add the sheet
   if the app replaced its stylesheet list.

   If anything here fails, the field falls back to plain radio buttons.
   ============================================================ */

(function () {
  'use strict';

  var HOST = 'shopify-forms-embed';
  var RATING_VALUES = '1,2,3,4,5';
  var POLL_MS = 250;
  var WAIT_MS = 20000;

  var script = document.currentScript;
  var cssUrl = script && script.getAttribute('data-css');
  if (!cssUrl || !('adoptedStyleSheets' in Document.prototype)) return;

  var sheet = new CSSStyleSheet();
  fetch(cssUrl)
    .then(function (res) { return res.text(); })
    .then(function (css) { return sheet.replace(css); })
    .catch(function () { /* no stars, plain radios */ });

  function adopt(root) {
    if (root.adoptedStyleSheets.indexOf(sheet) === -1) {
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
    }
  }

  function markRatingFields(root) {
    root.querySelectorAll('fieldset:not([data-fc-stars])').forEach(function (fieldset) {
      var values = Array.prototype.map.call(
        fieldset.querySelectorAll('input[type="radio"]'),
        function (input) { return input.value; }
      ).join(',');
      if (values === RATING_VALUES) fieldset.setAttribute('data-fc-stars', '');
    });
  }

  var attached = new WeakSet();

  function attach(host) {
    var root = host.shadowRoot;
    if (!root || attached.has(root)) return;
    attached.add(root);

    adopt(root);
    markRatingFields(root);
    new MutationObserver(function () {
      adopt(root);
      markRatingFields(root);
    }).observe(root, { childList: true, subtree: true });
  }

  var started = Date.now();
  var timer = setInterval(function () {
    var hosts = document.querySelectorAll(HOST);
    hosts.forEach(attach);

    var pending = Array.prototype.some.call(hosts, function (host) { return !host.shadowRoot; });
    if ((hosts.length && !pending) || Date.now() - started > WAIT_MS) clearInterval(timer);
  }, POLL_MS);
})();
